import { useCallback, useEffect, useRef, useState } from 'react';

const AUTO_ADVANCE_DELAY = 3000;
const SWIPE_THRESHOLD = 40;

export default function useMobileCarousel(itemCount) {
  const [activeSlide, setActiveSlide] = useState(0);
  const [touchStartX, setTouchStartX] = useState(null);
  const intervalRef = useRef(null);

  const startAutoScroll = useCallback(() => {
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setActiveSlide((currentSlide) => (currentSlide + 1) % itemCount);
    }, AUTO_ADVANCE_DELAY);
  }, [itemCount]);

  useEffect(() => {
    startAutoScroll();

    return () => clearInterval(intervalRef.current);
  }, [startAutoScroll]);

  const handleTouchStart = (event) => {
    clearInterval(intervalRef.current);
    setTouchStartX(event.touches[0]?.clientX ?? null);
  };

  const handleTouchEnd = (event) => {
    if (touchStartX === null) {
      startAutoScroll();
      return;
    }

    const touchEndX = event.changedTouches[0]?.clientX ?? touchStartX;
    const deltaX = touchStartX - touchEndX;

    if (Math.abs(deltaX) > SWIPE_THRESHOLD) {
      setActiveSlide((currentSlide) =>
        deltaX > 0
          ? Math.min(currentSlide + 1, itemCount - 1)
          : Math.max(currentSlide - 1, 0)
      );
    }

    setTouchStartX(null);
    startAutoScroll();
  };

  return {
    activeSlide,
    setActiveSlide,
    handleTouchStart,
    handleTouchEnd,
  };
}
